module.exports = __webpack_public_path__ + "../resources/img/ico-module-rotate.c1b3f6a9.svg";